(function(){
  function init(){
    if(document.getElementById("nomad-checkout-loader"))return;

    var style=document.createElement("style");

    style.textContent=
      '#nomad-checkout-loader{display:none;position:fixed;inset:0;z-index:2147483647;background:#08101E;align-items:center;justify-content:center;flex-direction:column;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}' +
      '.ncl-logo{color:#E8440A;font-size:13px;font-weight:700;letter-spacing:.25em;text-transform:uppercase;margin-bottom:40px;opacity:.9;}' +
      '.ncl-signal{display:flex;gap:6px;align-items:flex-end;height:32px;margin-bottom:40px;}' +
      '.ncl-signal span{width:5px;background:#E8440A;border-radius:3px;animation:ncl-bar 1.2s ease-in-out infinite;}' +
      '.ncl-signal span:nth-child(1){height:10px;animation-delay:0s;}' +
      '.ncl-signal span:nth-child(2){height:18px;animation-delay:.15s;}' +
      '.ncl-signal span:nth-child(3){height:26px;animation-delay:.3s;}' +
      '.ncl-signal span:nth-child(4){height:32px;animation-delay:.45s;}' +
      '.ncl-signal span:nth-child(5){height:22px;animation-delay:.6s;}' +
      '@keyframes ncl-bar{0%,100%{opacity:.25;transform:scaleY(.6)}50%{opacity:1;transform:scaleY(1)}}' +
      '.ncl-messages{position:relative;height:28px;width:280px;text-align:center;}' +
      '.ncl-msg{position:absolute;inset:0;color:#DBE3EC;font-size:15px;font-weight:400;letter-spacing:.02em;opacity:0;animation:ncl-fade 12s linear infinite;}' +
      '.ncl-msg:nth-child(1){animation-delay:0s;}' +
      '.ncl-msg:nth-child(2){animation-delay:3s;}' +
      '.ncl-msg:nth-child(3){animation-delay:6s;}' +
      '.ncl-msg:nth-child(4){animation-delay:9s;}' +
      '@keyframes ncl-fade{0%{opacity:0}4%{opacity:1}21%{opacity:1}25%{opacity:0}100%{opacity:0}}' +
      '.ncl-dots{display:flex;gap:8px;margin-top:32px;}' +
      '.ncl-dots span{width:6px;height:6px;border-radius:50%;background:#7DB1D8;animation:ncl-pulse 1.4s ease-in-out infinite;}' +
      '.ncl-dots span:nth-child(2){animation-delay:.2s;}' +
      '.ncl-dots span:nth-child(3){animation-delay:.4s;}' +
      '@keyframes ncl-pulse{0%,100%{opacity:.2;transform:scale(.8)}50%{opacity:1;transform:scale(1.15)}}';

    document.head.appendChild(style);

    var el=document.createElement("div");
    el.id="nomad-checkout-loader";
    el.setAttribute("aria-hidden","true");

    el.innerHTML=
      '<p class="ncl-logo">Nomad Internet</p>' +
      '<div class="ncl-signal">' +
        '<span></span>' +
        '<span></span>' +
        '<span></span>' +
        '<span></span>' +
        '<span></span>' +
      '</div>' +
      '<div class="ncl-messages">' +
        '<p class="ncl-msg">Checking your coverage area\u2026</p>' +
        '<p class="ncl-msg">Securing your discount\u2026</p>' +
        '<p class="ncl-msg">Preparing your checkout\u2026</p>' +
        '<p class="ncl-msg">Almost ready\u2026</p>' +
      '</div>' +
      '<div class="ncl-dots">' +
        '<span></span>' +
        '<span></span>' +
        '<span></span>' +
      '</div>';

    document.body.appendChild(el);

    function showLoader(){
      el.style.display="flex";
    }

    function hideLoader(){
      el.style.display="none";
    }

    var checkoutIds=[
      "cb-residential-standard",
      "cb-residential-advanced",
      "cb-travel-standard",
      "cb-travel-advanced",
      "cb-residential-standard-b",
      "cb-residential-advanced-b",
      "cb-travel-standard-b",
      "cb-travel-advanced-b",
      "pricing-cb-residential-standard",
      "pricing-cb-travel-standard"
    ];

    document.addEventListener("click",function(e){
      var target=e.target.closest("[id]");

      if(target && checkoutIds.indexOf(target.id)!==-1){
        showLoader();

        setTimeout(hideLoader,20000);
      }
    },true);

    var iframeObserved=false;

    function watchChargebeeIframe(){
      var cb=document.querySelector("#cb-frame");

      if(!cb || iframeObserved){
        return false;
      }

      iframeObserved=true;

      try{
        if(
          cb.contentDocument &&
          cb.contentDocument.readyState==="complete"
        ){
          hideLoader();
          return true;
        }
      }catch(err){}

      cb.addEventListener("load",function(){
        hideLoader();
      },{once:true});

      return true;
    }

    if(!watchChargebeeIframe()){

      var cbObs=new MutationObserver(function(){

        if(watchChargebeeIframe()){
          cbObs.disconnect();
        }

      });

      cbObs.observe(document.body,{
        childList:true,
        subtree:true
      });
    }
  }

  document.readyState==="loading"
    ? document.addEventListener("DOMContentLoaded",init)
    : init();

})();
